var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',[_c('p',[_vm._v("Регистрация закончена, мы направили Вам инструкцую на электронную почту: "),_c('span',[_vm._v(_vm._s(_vm.$route.params.email))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }